import { apiKey, domain, ingredient, region, formula, azureClientId, azureTenantId, stage, employee, picasso, outputDocument } from './config-current'
export const Stage = stage
export const ApiGateway =  { apiKey, domain, ingredient, region, formula, employee, picasso, outputDocument }
export const Azure = { azureClientId, azureTenantId }
